import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const SwitchService = ({ values }) => (
  <Content>
    {({
      switchBusinessSwitchServiceLabel,
      switchBusinessSwitchServiceValidationMessage,
      switchBusinessSwitchServiceValue1 = '',
      switchBusinessSwitchServiceValue2 = ''
    }) => (
      <Field
        name="switchService"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="switchService"
            title={switchBusinessSwitchServiceLabel}
            validationMessage={
              touched && !!error ? switchBusinessSwitchServiceValidationMessage : ''
            }
          >
            <GenericRadio.StackedSet
              groupName="switchService"
              items={[
                {
                  id: switchBusinessSwitchServiceValue1,
                  labelText: switchBusinessSwitchServiceValue1
                },
                {
                  id: switchBusinessSwitchServiceValue2,
                  labelText: switchBusinessSwitchServiceValue2
                }
              ]}
              {...input}
              selectedId={values.switchService}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default SwitchService;
